import { useCallback, useMemo, useState } from 'react';

import type { RootShareRecommendations } from 'src/app/pages/starterDashboardV2/shared/hooks';

import { useShareRecommendationsTracking } from '../../../../hooks/useShareRecommendationsTracking';

type FilterType = 'all' | 'reddit' | 'facebook';

export function useRecommendationsCarousel(shareRecommendations: RootShareRecommendations) {
	const [activeFilter, setActiveFilter] = useState<FilterType>('all');
	const {
		actions: { handleArrowButtonClick, handleChipClick },
	} = useShareRecommendationsTracking();

	const showChips = shareRecommendations.reddit.length > 0 && shareRecommendations.facebook.length > 0;

	const allRecommendations = useMemo(
		() => [
			...shareRecommendations.reddit.map((rec, index) => ({ ...rec, platform: 'reddit', index }) as const),
			...shareRecommendations.facebook.map((rec, index) => ({ ...rec, platform: 'facebook', index }) as const),
		],
		[shareRecommendations],
	);

	const filteredRecommendations = useMemo(
		() =>
			activeFilter === 'all' ? allRecommendations : allRecommendations.filter((rec) => rec.platform === activeFilter),
		[activeFilter, allRecommendations],
	);

	const handleFilterClick = useCallback(
		(platform: FilterType) => {
			setActiveFilter(platform);
			handleChipClick(platform, 'petition_dashboard_group_rec');
		},
		[handleChipClick],
	);

	const createScrollClickHandler = useCallback(
		(scrollByOneCard: (direction: 'left' | 'right') => void) => {
			return (direction: 'left' | 'right') => {
				scrollByOneCard(direction);
				handleArrowButtonClick(direction, 'petition_dashboard_group_rec');
			};
		},
		[handleArrowButtonClick],
	);

	return {
		activeFilter,
		showChips,
		filteredRecommendations,
		handleFilterClick,
		createScrollClickHandler,
	};
}
